'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sliderRewardsModuleContent = exports.rewardsModuleContent = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentHelpers = require('../component-helpers');

var _Sanitizer = require('acq-components/lib/base-components/Sanitizer/Sanitizer');

var _Link = require('acq-components/lib/base-components/Link/Link');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateModuleLink = function generateModuleLink(styles, column, dtmHelper, namespace) {
  return _react2.default.createElement(
    _Link.Link,
    {
      className: styles.benefitsLearnMoreLink,
      href: column.learnMore.dtm && column.learnMore.dtm.eventAsset ? dtmHelper.getUrlByLinkObj(column.learnMore, namespace) : column.learnMore.url,
      dtm: column.learnMore.dtm,
      namespace: namespace,
      title: column.learnMore.hoverText
    },
    column.learnMore.title
  );
};

var rewardsModuleContent = exports.rewardsModuleContent = function rewardsModuleContent() {
  var contentArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var contentStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var dtmHelper = arguments[3];

  return contentArray.map(function (x, i) {
    return {
      children: _react2.default.createElement(
        'div',
        { className: contentStyles.alignLinks, key: i },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Sanitizer.Sanitizer, {
            safelySetInnerHTML: x.header,
            className: contentStyles.headerTag,
            Component: 'h3'
          }),
          _react2.default.createElement(_componentHelpers.DescParser, { descArray: x.desc, InnerTag: 'p' })
        ),
        x.learnMore && generateModuleLink(contentStyles, x, dtmHelper, namespace)
      ),
      key: i,
      styles: contentStyles,
      direction: 'vertical',
      image: (0, _componentHelpers.getIconOrImage)(x, 0)
    };
  });
};

var sliderRewardsModuleContent = exports.sliderRewardsModuleContent = function sliderRewardsModuleContent() {
  var contentArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var contentStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var dtmHelper = arguments[3];

  return contentArray.map(function (x, i) {
    return x ? _react2.default.createElement(
      'div',
      { className: contentStyles.article, key: i },
      _react2.default.createElement(
        'div',
        { className: contentStyles.articleImageContainer },
        (0, _componentHelpers.getIconOrImage)(x, 0)
      ),
      _react2.default.createElement(
        'div',
        { className: contentStyles.contentHolder },
        _react2.default.createElement(_Sanitizer.Sanitizer, {
          safelySetInnerHTML: x.header,
          Component: 'h3',
          className: contentStyles.articleTitle
        }),
        _react2.default.createElement(_componentHelpers.DescParser, {
          descArray: x.desc,
          InnerTag: 'p',
          className: contentStyles.articleDesc
        })
      ),
      x.learnMore && generateModuleLink(contentStyles, x, dtmHelper, namespace)
    ) : null;
  });
};